import { CaptionStyle, CaptionStyleId } from '@t2c/ai-video-editor';

interface Props {
  captionStyle: CaptionStyle;
  setCaptionStyle: (value: CaptionStyle) => void;
}

export const useCaptionStyleSetup = ({ captionStyle, setCaptionStyle }: Props) => {
  const handleOnSelectCaptionStyle = (id: CaptionStyleId) => {
    setCaptionStyle({ ...captionStyle, captionStyleId: id });
  };
  return {
    handleOnSelectCaptionStyle,
  };
};
